import { WithStyles, withStyles } from '@mui/styles';
import { SortModel } from '@tassat/common-definitions';
import { FirmRecord } from '@tassat/fred-definitions';
import { Location } from 'history';

import { FirmUserDetails } from './firmUserDetails';
import { muiStyles } from './styles';

export interface FirmUserDetailsProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
    match: {
        params: {
            userId: string;
        };
    };
    editUser?: (user, deleteFunc) => void;
    closeModal?: () => void;
    history: any;
    location: Location<{ tab?: number; sortModel?: SortModel }>;
    isSSOEnabled: boolean;
}

export default withStyles(muiStyles)(FirmUserDetails);